import { AbstractInterface } from './AbstractInterface';
import { performanceMonitorService } from '../../../../service/performance-monitor';

export const BUCKET_ID = 'atlas-usecases';

const activeDurations: {
  [key: string]: () => any;
} = {};

export class PerformanceTracking extends AbstractInterface {

  static start(id: string): void {
    if (!activeDurations[id]) {
      activeDurations[id] = performanceMonitorService.trackDuration(BUCKET_ID, id);
    }
  }

  static end(ids: string[] = []): void {
    ids.forEach((id) => {
      if (activeDurations[id]) {
        activeDurations[id]();

        delete activeDurations[id];
      }
    });
  }

  static delete(id: string): void {
    if (activeDurations[id]) {
      delete activeDurations[id];
    }
  }
}
